import { ThemeProvider } from '@emotion/react';
import { createTheme } from '@mui/material/styles';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import StoryBody from 'components/organisms/StoryBody';
import { selectChat } from 'features/auth/chatSlice';
import React, { useEffect, useState } from 'react';
import { Body } from './DMessage.styles';
import { setCurrentIndex as indexSetter } from 'features/auth/chatSlice';
import InboxMessages from './InboxMessages';
import 'firebase/compat/firestore';
import InboxPeople from './InboxPeople';
import { selectAuth } from 'features/auth/authSlice';
import storiesData from 'components/organisms/StoryBody/dummyStories';
import ShareNftBody from 'components/organisms/ShareNftBody';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const DMessageBody = () => {
  const chatState = useAppSelector(selectChat);
  const authState = useAppSelector(selectAuth);
  const dispatch = useAppDispatch();
  const [currentTab, setCurrentTab] = useState<string>('General');
  const [storyShown, setStoryShown] = React.useState<boolean>(false);
  const [addStoryShown, setAddStoryShown] = React.useState<boolean>(false);
  const [storyIndex, setStoryIndex] = React.useState<number>(0);
  const handleChangeIndex = (i: number) => {
    dispatch(indexSetter(i));
  };

  const increaseStoryUI = () => {
    let newIndex = storyIndex + 1;
    if (newIndex > storiesData.length - 1) {
      hideStoryUI();
      return;
    } else if (newIndex < 0) {
      newIndex = 0;
      return;
    }
    setStoryIndex(newIndex);
    setStoryShown(true);
  };

  const decreaseStoryUI = () => {
    let newIndex = storyIndex - 1;
    if (newIndex > storiesData.length - 1) {
      newIndex = storiesData.length - 1;
    } else if (newIndex < 0) {
      newIndex = 0;
    }
    setStoryIndex(newIndex);
    setStoryShown(true);
  };

  const handleStoryUI = (i: number) => {
    setStoryIndex(i);
    setStoryShown(true);
  };

  const hideStoryUI = () => {
    setStoryShown(false);
    setStoryIndex(0);
  };

  const showAddStoryShown = () => {
    setAddStoryShown(true);
  };

  const hideAddStoryShown = () => {
    setAddStoryShown(false);
  };

  useEffect(() => {
    if (chatState.inboxUsers.length > 0 && authState) {
      const subscriberIds = authState.subscribers?.map(
        subscriber => subscriber.from.id
      );
      if (
        authState.generalChats.includes(
          chatState.inboxUsers[chatState.currentIndex].user.id
        )
      ) {
        setCurrentTab('General');
      } else if (
        subscriberIds?.includes(
          chatState.inboxUsers[chatState.currentIndex].user.id
        )
      ) {
        setCurrentTab('Backstage');
      } else {
        setCurrentTab('Requests');
      }
    }
  }, [authState.id, chatState.currentIndex]); //eslint-disable-line

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Body container>
          {/* <h2 style={{ position: 'absolute', left: '5%', top: '0px' }}>
            <TitleText>Direct Messages</TitleText>
          </h2> */}

          <InboxPeople
            handleChangeIndex={handleChangeIndex}
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
          />

          <InboxMessages
            data={
              (chatState.inboxUsers[chatState.currentIndex] &&
                chatState.inboxUsers[chatState.currentIndex].user) ||
              {}
            }
            handleStoryUI={handleStoryUI}
            currentIndex={chatState.currentIndex}
            showAddStoryShown={showAddStoryShown}
            hideAddStoryShown={hideAddStoryShown}
          />

          {storyShown && (
            <StoryBody
              data={storiesData[storyIndex]}
              hideStoryUI={hideStoryUI}
              increaseStoryUI={increaseStoryUI}
              decreaseStoryUI={decreaseStoryUI}
            />
          )}

          {addStoryShown && <ShareNftBody hideStoryUI={hideAddStoryShown} />}
        </Body>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default DMessageBody;
